export enum LabelType {
  printedLabel = "PrintedLabel",
  printerlessLabel = "PrinterlessLabel",
}
